"use strict";
/**
 * Provides some utility functions for somewhat efficiently modifying a
 * collection of headers.
 *
 * Note that this class only operates on ByteStrings (which is also why we use
 * toLowerCase internally).
 */

var _toConsumableArray = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var HeaderList =
/*#__PURE__*/
function () {
  function HeaderList() {
    _classCallCheck(this, HeaderList);

    this.headers = new Map();
  }

  _createClass(HeaderList, [{
    key: "append",
    value: function append(name, value) {
      var existing = this.headers.get(name.toLowerCase());

      if (existing) {
        name = existing[0].name;
        existing.push({
          name: name,
          value: value
        });
      } else {
        this.headers.set(name.toLowerCase(), [{
          name: name,
          value: value
        }]);
      }
    }
  }, {
    key: "contains",
    value: function contains(name) {
      return this.headers.has(name.toLowerCase());
    }
  }, {
    key: "get",
    value: function get(name) {
      name = name.toLowerCase();
      var values = this.headers.get(name);

      if (!values) {
        return null;
      }

      return values.map(function (h) {
        return h.value;
      }).join(", ");
    }
  }, {
    key: "delete",
    value: function _delete(name) {
      this.headers.delete(name.toLowerCase());
    }
  }, {
    key: "set",
    value: function set(name, value) {
      var lowerName = name.toLowerCase();
      this.headers.delete(lowerName);
      this.headers.set(lowerName, [{
        name: name,
        value: value
      }]);
    }
  }, {
    key: "sortAndCombine",
    value: function sortAndCombine() {
      var _this = this;

      var names = _toConsumableArray(this.headers.keys()).sort();

      return names.map(function (n) {
        return [n, _this.get(n)];
      });
    }
  }]);

  return HeaderList;
}();

module.exports = HeaderList;